<template>
  <div class="widget__poll" style="padding: 10px">
    <h1 class="widget__poll-title" style="line-height: 18px;font-size: 17px;" :class="!statusSelectTitle ? 'answer-err' : ''">{{ settings.feedback_text }} *</h1>
<!--    <h3 class="widget__poll-title">{{settings.football_club_save}}</h3>-->
    <div class="footer__poll">
      <div class="footer__poll-answer first-emodj" :class="statusYesEmodj ? 'answer-yes': 'answer-no'" @click="selectAnswer(true, 'yes')">
        <img
          style="width: 22px;"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL2SURBVHgBtVbBUhpBEJ2erJjkhLcUeFgvqWg8yBeoXyB/oPkCyU1Jqlguyi3wBeIXJH6B8AVolUJVLuwF5Ja9mOASptM9wyrssgSSsqummN2Zed39tvsNIGaY7bSTvt8/BMQdpEdhBpsLPEB8sxRcuKV1Nw4DpgIftewB4BmB7jy9RY+2e8GWCRDA6pKSxWmOIg5W881DhejQUlKDoqgkhKyGD6fzN1sgrG2FKjdy6FFAxbvTjXKsg1S+VRAanAPGYrf03hFzWOro1qE0CqN0nO7JejHiwEQuyhw1pbzbOdm8EgsYZ4QIl5w5ZfIxyEQ7YM59UA1eBFCZRcEnnUjCEV4CIcO0Sl4YSFXQnBMt/wrOps8CMj1JLhKdgYke2zR3u6cba+MHuEwHD78KCqR7d/KuMr7GlCIKewmhEi6A1PHtDw44sfxqRQ5gmOWXxFslHNHAv8/S+xygKqfz37eeHDeS/L14zZeiEEkFDJbv/8wRRXKPHyRYtcg+9cI1M/SGahj0gHCdDM/1GiJeh88pJav6PMI2pdNs00ARY0wTj6lrRG/cOaaJsS1hmsSN2+g6a17s2gyJGHW9LcUzGztwaUQoYFooxezfALiaYii0GVvCyMGbMJ/+PT9/neWEGuuAq6nf7084sKnh+JexJQLWdSpSHYxvcnXDqXOanqU/tfbD4KufWzskDV+ohCu90LcYoFFhJcQFcE37D8vUGMKjRluJRHl0U0aQhzS9Io0yXY5gaylHcd4tbRyEz3D1cCIKYU1yTVMqNXqRTOVJFUPWKW3mKM1dml4zsB6AnPruVHBWZOYfoMqZabFj/uWj2Fkkdm//U+zQUygzvUDsjCfQGo74+3JcFhYDZ7lm2YFi8F0e+6DD+o1GCclJY5TqXMZ7TeRGkcdvtciVmT5u5lCgkW9TxyRqVj1Mm+2QCvtiX+gr01yvHPnMKzMw80301RkuT9f8YHIUQABSGyJ86M1z6YcdWRL2EFV22t8WUtJ64uXr8iy9+gNiOJEbmCzORgAAAABJRU5ErkJggg=="
          class="emoji">
        <span class="answer"> {{ settings.poll_yes }}</span>
      </div>
      <div class="footer__poll-answer" :class="statusNoEmodj ? 'answer-yes': 'answer-no'" @click="selectAnswer(true, 'no')">
        <img
          style="width: 22px;"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ9SURBVHgBtVXbcdpAFN0VguEvSgekgkAFVj4ZYDAVmFSAXQGiAnAFJhXwHj6DKzAdRB1E/7xyzvpuZi0LBmP7zmi0j3vPfd/V6gSNRqOgUCh0DodDiG1JPlKCb621HnueN6lWq/ExDJ11uFwuS7vd7gHLUJ1Hw1wu18tS5KUPFotFB+BPAp7A+vv9ft8CwLd6va75cc0zfL9ErE2Z+Xx+q055APAuACNr1WazuWu1Wok6QfQWfBFCdWMAtY5qtVrvlQJaDvCBbO9g6UC9gcT6flpeWyskLMEl4BlKEoSxwpyYHAC8K+DDS8FJlJW8BFIkSov1f7hh8txKkLvfcvfD3k2n02vEnAAxQCuuEpZ2Pp8nXoDcfPUAcC13w3SZgSFUUv9Yl+05EhmKx2Ua4cqwKJBLU12+79/6+De5gWsTlSIoH+MXwvovWK/sOQQH2H/HMrPJoGAFIzr4rjQS85fWpMPzHnLCbpJMV9VHgaewSp76ZGIOYmqiW1leyMBjl4aIrfEWsWV3r44NOgkRl4knCpRbJRaYo4Mlx/Eh4OSNuWbXM87I4QN5XVkHa+2D8ZFlJ6U3tuAAfhKg++12O0jPJOFpY9khL/YVywPPmsI28Sgsbt+4lmC/Zrs3Go0oa+DxjJ3LBiRvsVgMbHjwo2I259jMIrjJbg3V86j4qd5BDJkoMFieaCIorWxnzfRziRNZwDnszMg2CqQS7AzvX6IkNe7/v24vHpzZbBYhnl3ZHn0GXZJk98Vyjoke82bvX73JYr0d30YR5xRA1laZvGJlVMuVAJOXIe6lx/3RR999Bs+gFfOY5a0+JUVFsL4JtznSy45XsXpuuMesHnHpH0/5jZyLvx7GAAAAAElFTkSuQmCC"
          class="emoji">
        <span class="answer"> {{ settings.poll_no }}</span>
      </div>
    </div>
    <p class="footer__poll-title" style="margin-bottom: -1px; margin-top: 4px; line-height: 18px; font-size: 15px">{{ settings.feedback_comment }}</p>
    <textarea
      style="min-height: 80px; margin-top: 5px"
      maxlength="500"
      v-model="comment"
      class="widget__poll-comment"
      :class="validComment ? 'search-err' : ''"
    />
    <button v-bind:style="{ backgroundColor: settings.theme_color}" class="widget__poll-save" @click="answerOnPoll">
      {{settings.form_save}}
    </button>
  </div>
</template>

<script>
import {closeWidget} from '../services/closeWidget'
export default {
  name: 'widgetPoll',
  mixins: [closeWidget],
  mounted () {
    this.settings = this.$settings
  },
  data () {
    return {
      statusSelectTitle: true,
      statusYesEmodj: false,
      statusNoEmodj: false,
      validComment: false,
      settings: {},
      answerPoll: '',
      comment: ''
    }
  },
  methods: {
    selectAnswer (answer, type) {
      if (type === 'yes') {
        this.statusYesEmodj = answer
        this.statusNoEmodj = false
        this.answerPoll = type
      } else {
        this.statusNoEmodj = answer
        this.statusYesEmodj = false
        this.answerPoll = type
      }
    },
    answerOnPoll () {
      this.validComment = !this.comment.length
      let ask = {
        answer: this.answerPoll === 'yes' ? 1 : 0,
        comment: this.comment,
        action_id: this.$askData.action_id,
        lang: this.$askData.lang,
        uid: this.$askData.uid,
        brand: this.$askData.brand,
        currency: this.$userInfo.currency,
        user_id: this.$askData.user_id
      }
      if (this.answerPoll.length !== 0) {
        this.statusSelectTitle = true
        if (this.answerPoll === 'yes') {
          this.answerOnWidget(ask)
        } else {
          if (!this.validComment) {
            this.answerOnWidget(ask)
          }
        }
      } else {
        this.statusSelectTitle = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WidgetPoll.vue